/* Angular Component */
import {
  Component,
  Output,
  Input,
  EventEmitter,
  ElementRef,
  OnChanges,
  OnInit,
} from "@angular/core";
import moment from "moment";
import { isBroadcastPresetShowLike } from "../../../../domain/show";

@Component({
  selector: "calendar-header-dropdown",
  templateUrl: "./calendar-header-dropdown.component.html",
  styleUrls: ["./calendar-header-dropdown.component.scss"],
})
export class CalendarHeaderDropdownComponent implements OnChanges, OnInit {
  @Output()
  output = new EventEmitter();


  @Output()
  clearPrerollsClicked = new EventEmitter();

  @Input()
  initValue;

  @Input()
  label;

  @Input()
  placeholder;

  @Input()
  options;

  @Input()
  enabled = false;

  @Input()
  textEllipsis: number = 200;

  listOpen = false;
  listDown = true;
  value;
  lastSelected;
  multiple: boolean;

  constructor(private ref: ElementRef) {}

  ngOnInit() {
    this.setupInitValue();
  }

  /**
   * Resetting Value
   * @return void
   */
  resetValue() {
    this.value = {
      label: "",
      data: [],
    };

    this.options.map((option, index, options) => {
      options[index]["selected"] = false;
    });
  }

  ngOnChanges(changes) {

    const index = !changes["options"]
      ? -1
      : this.options.findIndex((item) => item?.id === this.lastSelected?.id);
    if (this.enabled && !changes["enabled"] && index == -1) {
      this.setupInitValue();
    } else {
      //console.log('calendar-header-dropdown->ngOnChanges->setupInitValue()', changes['options'].currentValue, changes['options'].currentValue.find(item => item?.id === this.lastSelected?.id));
      if(this.options[index]) {

        this.assginSingleValue(this.options[index]);
        this.options[index].selected = true;
      }

    }

    if (changes["initValue"]) {
      this.setupInitValue();
      if (this.lastSelected) {
        if (index > 0) {
          this.setSelectedValue(index);
        }
      }
    }
  }

  /**
   * Setup Init Value (Make changes in view according to supplied data)
   * @return void
   */
  setupInitValue() {
    /* Reset Value */
    this.resetValue();

    /* Prevent undefined iteration */
    if (!this.initValue) {
      if (this.placeholder) {
        const ph = {};
        ph["name"] = this.placeholder;
        this.assginSingleValue(ph);
      }
      return;
    }
    const mapper = {};

    /* Mapping the items */
    this.options.map(
      ((item, index) => {
        mapper[item["name"]] = index;
      }).bind(this),
    );

    // console.log("SINGLE VALUE: ", this.initValue);
    if (this.options.length > 0) {
      this.setSelectedValue(0);
    }
  }

  setSelectedValue(index) {
    this.clearOthers();
    this.assginSingleValue(this.options[index]);
    this.options[index].selected = true;
    this.updateOutput();
  }

  /**
   * Opening The List
   * @return void
   */
  toggleList() {
    /*if (this.options) {
      if (this.options.length === 0) {
        this.listOpen = false;
      } else {

      }
    }*/

    this.listOpen = !this.listOpen;
  }

  assginSingleValue(option) {
    if (option) {
      this.value = {
        label: option["name"],
        data: [option],
      };
    }
  }

  isBroadcastPresetSkipBlocked(option: unknown): boolean {
    return isBroadcastPresetShowLike(option);
  }

  selectOption(option, index) {
    if (this.isBroadcastPresetSkipBlocked(option)) {
      return;
    }

    this.clearOthers();

    this.options[index].selected = true;
    this.assginSingleValue(option);

    this.updateOutput();
    this.lastSelected = this.value.data[0];
    this.toggleList();
  }

  clearPrerollList() {
    this.clearOthers();
    this.resetValue();
    const ph = {};
    ph["name"] = this.placeholder;
    this.assginSingleValue(ph);

    this.lastSelected = null;
    this.toggleList();

    this.clearPrerollsClicked.emit();
  }

  /**
   * Updating Value Label
   * @return void
   */
  updateValueLabel() {
    const labelParts = [];

    this.value.data.forEach(function (item) {
      labelParts.push(item["name"]);
    });

    this.value.label = labelParts.join(", ");
  }

  /**
   * Updating Output
   * @return void
   */
  updateOutput() {
    if (this.options.length > 0) {
      this.output.emit(this.value);
    }
  }

  /**
   * Clearing preselected items
   * @return void
   */
  clearOthers() {
    for (let index = 0; index < this.options.length; index++) {
      this.options[index].selected = false;
    }
  }

  onClickOutside(event) {
    if (!this.ref.nativeElement.contains(event.target)) {
      if (this.listOpen) {
        this.toggleList();
      }
    }
  }
  durationFormat(duration: moment.Duration) {
    if (
      !duration ||
      typeof (duration as moment.Duration).asMilliseconds !== "function"
    ) {
      return "00:00:00";
    }
    return moment.utc(duration.asMilliseconds()).format("HH:mm:ss");
  }
}
